import { format } from "date-fns";

export const getMin = (items, key) => {
  if (!Array.isArray(items)) return 0;
  let min = -1;
  items.forEach((item) => {
    const value = item[key];
    if (min === -1 && value != null) min = value;
    if (value != null && value < min) min = value;
  });
  return min;
};

export const getMax = (items, key) => {
  if (!Array.isArray(items)) return 0;
  let max = -1;
  items.forEach((item) => {
    const value = item[key];
    if (max === -1 && value != null) max = value;
    if (value != null && value > max) max = value;
  });
  return max;
};

export const getValues = (items, key) => {
  if (!Array.isArray(items)) {
    console.error("items is not an array:", items);
    return [];
  }
  const values = [];
  items.forEach((item) => {
    if (item[key] && !values.includes(item[key])) values.push(item[key]);
  });
  return values;
};

export function createWorkFilterOptions(works) {
  return [
        { label: "Client", vkey: "client.name", type: "string", value: "" },
        { label: "Name", vkey: "name", type: "string", value: "" },
        {
          label: "Paid",
          vkey: "paid",
          type: "interval",
          min: getMin(works, "paid"),
          max: getMax(works, "paid")
        },
        {
          label: "Status",
          vkey: "status",
          type: "valueList",
          values: getValues(works, "status"),
          value: getValues(works, "status")
        },
        {
          label: "Measured",
          vkey: "measureDate",
          type: "interval",
          min: getMin(works, "measureDate"),
          max: getMax(works, "measureDate")
        },
        {
          label: "Ordered",
          vkey: "orderDate",
          type: "interval",
          min: getMin(works, "orderDate"),
          max: getMax(works, "orderDate")
        },
        {
          label: "Completed",
          vkey: "finishDate",
          type: "interval",
          min: getMin(works, "finishDate"),
          max: getMax(works, "finishDate")
        }
      ];
}

export function updateWorkFilterOptions(options, key, type, actionType, value) {
  return options.map((config) => {
      if (config.vkey === key) {
        let newConfig = { ...config };
        if (type === "string") {
          newConfig.value = value;
        } else if (type === "interval") {
          if (actionType === "min") {
            newConfig.min = value;
          } else {
            newConfig.max = value;
          }
        } else if (type === "valueList") {
          if (newConfig.value.includes(value)) {
            newConfig.value = newConfig.value.filter((val) => val !== value);
          } else {
            newConfig.value = [...newConfig.value, value];
          }
        }
        return newConfig;
      }
      return config;
    });
}

export const formatWorkDate = (dateString, t, dateLocale) => {
    if (!dateString) return t("none");

    try {
      return format(new Date(dateString), "P", {
        locale: dateLocale
      });
    } catch {
      return t("none");
    }
  };

export const WORK_SORT_OPTIONS = [
    { label: "Client", value: "client.name" },
    { label: "Name", value: "name" },
    { label: "Paid", value: "paid" },
    { label: "Status", value: "status" },
    { label: "Measured", value: "measureDate" },
    { label: "Ordered", value: "orderDate" },
    { label: "Completed", value: "finishDate" }
  ];


export function getNextWorkSortConfig(current, key) {
  return { key, direction: current?.key === key && current.direction === 1 ? 2 : 1 };
}

const dateSortValue = (value) => {
  if (!value) return null;
  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? null : timestamp;
};

export function createWorkRow(work, isUser, t, dateLocale) {
  return {
    workId: work.workId,
    id: work.workId || t("none"),
    partyName: (isUser ? work.client?.name : work.user?.name) || t("none"),
    name: work.name || t("none"),
    paid: (isUser ? work.paid : work.userPaid) ?? "0",
    price: (isUser ? work.price : work.companyPrice) ?? "0",
    laborCost: (isUser ? work.label : work.companyLabel) ?? t("none"),
    status: t(isUser ? work.status : work.companyStatus),
    measureDate: formatWorkDate(work.measureDate, t, dateLocale),
    orderDate: formatWorkDate(work.orderDate, t, dateLocale),
    finishDate: formatWorkDate(isUser ? work.finishDate : (work.companyFinishDate ?? work.companyFinished), t, dateLocale),
    sortDates: {
      measureDate: dateSortValue(work.measureDate),
      orderDate: dateSortValue(work.orderDate),
      finishDate: dateSortValue(isUser ? work.finishDate : (work.companyFinishDate ?? work.companyFinished)),
    },
    canDelete: !work.isOrdered
  };
}

export function createWorkFilterViewOptions(options) {
  return options.map((option) => {
    const isDateInterval = option.type === "interval" && option.vkey.toLowerCase().includes("date");
    return {
      ...option,
      isDateInterval,
      displayMin: isDateInterval ? (option.min ? new Date(option.min).toISOString().split("T")[0] : "") : option.min || "",
      displayMax: isDateInterval ? (option.max ? new Date(option.max).toISOString().split("T")[0] : "") : option.max || ""
    };
  });
}
